import { RecommendationsState } from '../../../models';
import { RECOMMENDATIONS_MUTATIONS_KEYS } from '../recommendations.const';
import { RecommendationsMutation } from '../recommendations.interfaces';

export class SetLoadingMutation implements RecommendationsMutation {
  mutations = {
    [RECOMMENDATIONS_MUTATIONS_KEYS.setLoading]: (recommendationsState: RecommendationsState, loading: boolean) => {
      recommendationsState.loading = loading;
    }
  };
}
